define.alias("shared/components/shared/color-picker", "calendar/components/shared/color-picker");